import { Dialog } from 'braid-design-system';
import { useId, type ComponentProps } from 'react';

import type {
  LiveClientPayload,
  PublicTestClientPayload,
} from '#src/api/index.ts';
import { displayNameForDataType } from '#src/utils/credentials.ts';

import { DeleteCredentialDialogBody } from './DeleteCredentialDialogBody.tsx';

interface Props extends Pick<
  ComponentProps<typeof Dialog>,
  'open' | 'onClose'
> {
  client: LiveClientPayload | PublicTestClientPayload;
  liveClientCount: number;
  onDelete: () => void;
}

export const DeleteCredentialDialog = ({
  client,
  open,
  onClose,
  ...props
}: Props) => (
  <Dialog
    open={open}
    onClose={onClose}
    id={useId()}
    title={`Delete ${displayNameForDataType(client.type)} credentials`}
  >
    <DeleteCredentialDialogBody {...props} client={client} onClose={onClose} />
  </Dialog>
);
